import template from './employee_view_notes_component.html';
import * as Utils from '../../lib/savanna_utils.js';
import * as Permissions from '../../lib/permission_utils.js';
import tr from '../../lib/default-translator.js';
import ClassicEditor from '../../lib/ckeditor/build/ckeditor.js';
import ClassicEditorConfig from '../../lib/ClassicEditorConfig.js';

class EmployeeViewNotesComponentViewModel
{
	constructor(bindings)
	{
		this.notes_logged = ko.observableArray([]);
		this.note = ko.observable('');
		this.employee_id = ko.observable();
		this.editing_note_id = ko.observable(null);
		this.employee = ko.observable();
		this.logged_in_employee_id = Utils.get_local_storage_nullable('employee_id');
		this.loader = ko.observable(false);

		if (bindings.employee && ko.isObservable(bindings.employee))
		{
			bindings.employee.subscribe((nv) =>
			{
				if (nv)
				{
					this.employee(nv);
					this.employee_id(nv.employee_id);
					this.updateData();
				}
			});
		}
	};

	async updateData()
	{
		this.enable_ckeditor();
		this.loadPage();
	};

	async loadPage()
	{
		if ((await Permissions.checkAccessRights('EmployeeNotes')) === true)
		{
			let options = {
				table: 'employee_note',
				schema: 'public',
				limit: 1000000,
				sortfield: 'note_logged_date',
				sortorder: 'DESC',
				filter: [{
					field: 'employee_id',
					operand: '=',
					value: this.employee_id()
				}]
			}
			let result = await Grape.fetches.getJSON('/api/record', options);
			if (result.status == 'OK')
				this.notes_logged(result.records);
		}
	};

	/** delete note **/
	async delete_note(data)
	{
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete this note ?')});
		if (response)
		{
			let info = ko.mapping.toJS(data);
			let res = await Grape.fetches.postJSON('/employee/delete_employee_note', info);
			
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted note.'), title: tr('Success', 'Success') });
				this.updateData();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error') });
		}
	};

	/** save note **/
	async save_employee_note(data)
	{
		let options = {
			employee_id: this.employee_id(),
			note: this.editor.getData() // ckEditor get textarea data
		};

		this.loader(true);

		if (options.note && options.note.trim().length > 0)
		{
			let result;
			if (this.editing_note_id)
			{
				options.employee_note_id = this.editing_note_id;
				result = await Grape.fetches.postJSON('/employee/edit_employee_note', options);
			} 
			else
				result = await Grape.fetches.postJSON('/employee/edit_employee_note', options);

			this.loader(false);

			if (result.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr(this.editing_note_id ? 'Successfully edited employee note' : 'Successfully added employee note'), title: tr('Success', 'Success') });
				this.updateData();
				this.editor.setData(' ');
				this.editing_note_id = null;
			}
			else if (result.status == 'ERROR')
				Grape.alerts.apiError(result);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error') });
		}
		else
		{
			Grape.alerts.alert({type: 'warning', message: tr('You can not save an empty note'), title: tr('Invalid Note', 'Invalid Note')});
			this.loader(false);
		}
	};

	async edit_note(data) 
	{
		this.editing_note_id = data.employee_note_id;
		this.editor.setData(data.note);
	}

	async enable_ckeditor()
	{
		// load the ckeditor
		if (!this.editor)
			ClassicEditor.create(
				document.getElementById('employee_notes_editor'),
					Object.assign({}, ClassicEditorConfig, {
						height: '20em',
						toolbar: {
							items: [
								'|', 'bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript',
								'|', 'removeFormat', '|', 'Link' ,'|',  'undo', 'redo'
							]
						},
					})
				).then((editor) => {
					this.editor = editor;
					this.editor.setData(this.note());
				}).catch((err) => {
					console.error(err);
					console.trace();
				});
	};

	show_notes_help()
	{
		Grape.dialog.open('NotesHelp', { employee_id: this.employee_id() });
	};
};

export default {
	name: 'employee_view_notes_component',
	viewModel: EmployeeViewNotesComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/employee_view_notes_component'
};
